import { EntityInput, LinkProps } from "helpers/url";

export function analogiHref(
  entity: EntityInput,
  origin?: string
): LinkProps["href"] {
  return analogiAs(entity, origin);
}

export function analogiAs(
  entity: EntityInput,
  origin?: string
): LinkProps["as"] {
  const category = entity?.category || "";

  const analogi = category.match("/analogi")
    ? category
    : `${category}/analogi/`;

  const path = `${analogi}${analogi.endsWith("/") ? "" : "/"}`;

  if (origin) {
    return `${origin}/${path}`;
  }

  return path;
}
